import { all } from 'redux-saga/effects';
import paySlipWatcher from './payslip-saga';

export default function* rootSaga(action) {
	yield all([paySlipWatcher(action)]);
}